const OilIcon = (props: any) => (
    <svg
        width={34}
        height={28}
        viewBox="0 0 34 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Oil"
        {...props}
    >
        <path
            d="M0.545455 14C0.545455 6.56926 6.56926 0.545455 14 0.545455H20C27.4307 0.545455 33.4545 6.56926 33.4545 14C33.4545 21.4307 27.4307 27.4545 20 27.4545H14C6.56926 27.4545 0.545455 21.4307 0.545455 14Z"
            fill="#FFFAEB"
        />
        <path
            d="M0.545455 14C0.545455 6.56926 6.56926 0.545455 14 0.545455H20C27.4307 0.545455 33.4545 6.56926 33.4545 14C33.4545 21.4307 27.4307 27.4545 20 27.4545H14C6.56926 27.4545 0.545455 21.4307 0.545455 14Z"
            stroke="#EFDCAB"
            strokeWidth={1.09091}
        />
        <path
            d="M8.48481 9.72C9.54081 8.664 10.8635 8.136 12.4528 8.136C14.0421 8.136 15.3648 8.664 16.4208 9.72C17.4768 10.776 18.0048 12.0933 18.0048 13.672C18.0048 15.2507 17.4768 16.568 16.4208 17.624C15.3648 18.68 14.0421 19.208 12.4528 19.208C10.8635 19.208 9.54081 18.68 8.48481 17.624C7.42881 16.568 6.90081 15.2507 6.90081 13.672C6.90081 12.0933 7.42881 10.776 8.48481 9.72ZM9.63681 16.584C10.3728 17.3307 11.3115 17.704 12.4528 17.704C13.5941 17.704 14.5328 17.3307 15.2688 16.584C16.0048 15.8267 16.3728 14.856 16.3728 13.672C16.3728 12.488 16.0048 11.5227 15.2688 10.776C14.5328 10.0187 13.5941 9.64 12.4528 9.64C11.3115 9.64 10.3728 10.0187 9.63681 10.776C8.90081 11.5227 8.53281 12.488 8.53281 13.672C8.53281 14.856 8.90081 15.8267 9.63681 16.584ZM19.7654 12.264H21.3334V19H19.7654V12.264ZM19.8294 10.2C19.6374 10.008 19.5414 9.768 19.5414 9.48C19.5414 9.192 19.6374 8.952 19.8294 8.76C20.0214 8.568 20.2614 8.472 20.5494 8.472C20.8374 8.472 21.0774 8.568 21.2694 8.76C21.4614 8.952 21.5574 9.192 21.5574 9.48C21.5574 9.768 21.4614 10.008 21.2694 10.2C21.0774 10.392 20.8374 10.488 20.5494 10.488C20.2614 10.488 20.0214 10.392 19.8294 10.2ZM23.3123 7.336H24.8803V19H23.3123V7.336Z"
            fill="#603C3A"
        />
    </svg>
);

export default OilIcon;
